var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5037_287104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 26.5417C7.88675 26.5417 2.91675 21.5717 2.91675 15.4583C2.91675 9.345 7.88675 4.375 14.0001 4.375C20.1134 4.375 25.0834 9.345 25.0834 15.4583C25.0834 21.5717 20.1134 26.5417 14.0001 26.5417ZM14.0001 6.125C8.85508 6.125 4.66675 10.3133 4.66675 15.4583C4.66675 20.6033 8.85508 24.7917 14.0001 24.7917C19.1451 24.7917 23.3334 20.6033 23.3334 15.4583C23.3334 10.3133 19.1451 6.125 14.0001 6.125Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16.0416C13.5217 16.0416 13.125 15.6449 13.125 15.1666V9.33325C13.125 8.85492 13.5217 8.45825 14 8.45825C14.4783 8.45825 14.875 8.85492 14.875 9.33325V15.1666C14.875 15.6449 14.4783 16.0416 14 16.0416Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.20825H10.5C10.0217 3.20825 9.625 2.81159 9.625 2.33325C9.625 1.85492 10.0217 1.45825 10.5 1.45825H17.5C17.9783 1.45825 18.375 1.85492 18.375 2.33325C18.375 2.81159 17.9783 3.20825 17.5 3.20825Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5037_287104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.9d667b855d1fad299224c20e2d333439.svg";
export { ForwardRef as ReactComponent };